import { render, staticRenderFns } from "./project-bulletin-report.vue?vue&type=template&id=964d9bfa&"
import script from "./project-bulletin-report.vue?vue&type=script&lang=js&"
export * from "./project-bulletin-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports